module.exports = __webpack_public_path__ + "static/pricing-mobile-b8c7c894f91158a8c199c94fa99964e0.png";